import { Button, makeStyles, TextField } from '@material-ui/core';
import { useContext, useState } from 'react';
import logo from '../../assets/images/logo.png';
import { LoginContext } from '../../context/LoginProvider';

const useStyles = makeStyles((theme) => ({
  input: {
    width: '25%',
  },
  container: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginButton: {
    width: '10%',
  },
}));

function useForm() {
  const [values, setValues] = useState({});

  return [
    values,
    (e) => {
      setValues({
        ...values,
        [e.target.name]: e.target.value,
      });
    },
  ];
}

export function Login(props) {
  const classes = useStyles();
  const [values, handleChange] = useForm();
  const { setUser } = useContext(LoginContext);

  const login = () => {
    fetch('https://api.edicionesmilenio.com/api/admins/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    })
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem('user', JSON.stringify(data?.data));
        setUser(data?.data);
      });
  };

  return (
    <div className={classes.container}>
      <img style={{ width: '350px' }} src={logo} alt="logo" />
      <TextField
        id="username"
        label="Nombre de usuario"
        variant="outlined"
        margin="normal"
        className={classes.input}
        name="username"
        onChange={handleChange}
        value={values?.username}
      />
      <TextField
        id="password"
        label="Contraseña"
        variant="outlined"
        margin="normal"
        className={classes.input}
        name="password"
        onChange={handleChange}
        value={values?.password}
        type={'password'}
      />
      <Button
        onClick={login}
        className={classes.loginButton}
        variant="outlined"
        color="primary"
      >
        Iniciar sesión
      </Button>
    </div>
  );
}
